export enum ReportTypes {
  // Note: These values are also used for keys in translation files. Change only if you know what you're doing!!
  WASTE_EVENTS = 'maxi_extended',
  ARTICLE = 'standard',
  RND_CODE = 'recycling_and_disposal',
  ENVIRONMENTAL = 'environment',
  ARTICLES_SUMMARY = 'articles_summary',
  CO2_EMISSIONS = 'co2_emissions',
}

export const isValidReportType = (value?: string): value is ReportTypes => {
  return value !== undefined && Object.values(ReportTypes).includes(value as ReportTypes);
};
